import { Card, Typography, theme } from "antd";

const { Title, Paragraph } = Typography;
const { useToken } = theme;

const FeatureCard = ({ icon: Icon, title, description }) => {
	const { token } = useToken();

	return (
		<Card hoverable style={{ height: "100%", textAlign: "center" }}>
			<Icon
				style={{
					fontSize: "48px",
					marginBottom: "16px",
					display: "block",
					color: token.colorPrimary,
				}}
			/>
			<Title level={4} style={{ marginBottom: "16px" }}>
				{title}
			</Title>
			<Paragraph style={{ fontSize: "16px", marginBottom: 0 }}>
				{description}
			</Paragraph>
		</Card>
	);
};

export default FeatureCard;
